import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector, useDispatch } from 'react-redux';
import { LoadingButton } from '@hmhco/loading-button';
import { getCurrentOrg } from '../../../../store/selectors/CountryStateOrg';
import useStyles from './EarlyAccessButtons.styles';
import {
  setEarlyAccessError,
  setEarlyAccessLoading,
  setEarlyAccessStep,
  setEarlyAccessSuccess,
} from '../../../../store/actions/EarlyAccessActions';
import {
  getEarlyAccessStep,
  getIsEarlyAccessEmailValid,
} from '../../../../store/selectors/EarlyAccessPageState';

const EarlyAccessButtons = () => {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const earlyAccessStep = useSelector(getEarlyAccessStep);
  const isEmailValid = useSelector(getIsEarlyAccessEmailValid);
  const currentOrg = useSelector(getCurrentOrg);

  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async event => {
    event.preventDefault();
    if (earlyAccessStep === 1) {
      dispatch(setEarlyAccessStep(2));
    } else {
      try {
        setIsLoading(true);
        dispatch(setEarlyAccessLoading());
        // Simulate API request with 2 second delay
        // await new Promise(resolve => setTimeout(resolve, 2000));
        await new Promise((resolve, reject) => {
          setTimeout(() => reject(new Error('Simulated API error')), 2000);
        });
        setIsLoading(false);
        dispatch(setEarlyAccessSuccess());
      } catch (error) {
        setIsLoading(false);
        dispatch(setEarlyAccessError());
      }
    }
  };

  const getButtonText = () => {
    if (earlyAccessStep === 1) {
      return 'edEarlyAccess.edEarlyAccess.continueButton';
    }
    return 'edEarlyAccess.edEarlyAccess.submitButton';
  };

  useEffect(() => {
    if (earlyAccessStep === 1) {
      const hasOrg = !!currentOrg?.name;
      setButtonDisabled(!hasOrg);
    } else if (earlyAccessStep === 2 && isEmailValid) {
      setButtonDisabled(false);
    } else {
      setButtonDisabled(true);
    }
  }, [earlyAccessStep, currentOrg, isEmailValid]);

  return (
    <div className={classes.buttons}>
      <FormattedMessage id={getButtonText()}>
        {([label]) => (
          <LoadingButton
            loading={isLoading}
            disabled={buttonDisabled}
            buttonProps={{
              children: label,
              color: 'primary',
              className: classes.button,
              variant: 'contained',
              size: 'small',
              onClick: handleClick,
              type: 'submit',
            }}
            loadingText={label}
          />
        )}
      </FormattedMessage>
    </div>
  );
};

export default EarlyAccessButtons;
